module.exports = __webpack_public_path__ + "a55e489306a5ad2973cd116f0e0f3d.png";